<template>
  <PolicyLayout :page="page" />
</template>

<script>
import PolicyLayout from "./PolicyLayout.vue";
import { loadSiteContent } from "@/services/siteContent";

export default {
  components: { PolicyLayout },
  data() {
    return {
      page: {
        eyebrow: "隐私政策",
        title: "隐私政策",
        lead: "本页面说明 pizzaking 如何处理提供服务所需的账号、使用记录和安全相关信息。",
        sourceLabel: "PizzaKing 版本 · 2026",
        sections: [
          {
            title: "我们处理的信息",
            text:
              "我们可能处理手机号、账号名、登录状态、余额记录、玩法记录、库存数据、设备数据、Cookie 和平台运行所需的使用日志。",
          },
          {
            title: "信息用途",
            text:
              "这些信息用于账号访问、打开箱子、箱子战斗、升级、库存展示、充值记录、客服支持和平台安全。",
          },
          {
            title: "安全措施",
            text:
              "平台通过运营和技术措施降低未授权访问、账号滥用、支付风险和异常玩法行为。",
          },
          {
            title: "第三方处理",
            text:
              "当接入支付、发货或统计服务商时，相关信息可能仅为完成必要服务流程而由服务商处理。",
          },
          {
            title: "用户权利",
            text:
              "用户可就账号信息、更正请求、安全问题或政策疑问联系平台客服。",
          },
          {
            title: "政策更新",
            text:
              "当平台功能、服务商或法律要求发生变化时，本政策可能进行更新。",
          },
        ],
      },
    };
  },
  mounted() {
    loadSiteContent(this.$axios).then((content) => {
      this.page = content.privacy;
    });
  },
};
</script>
